import { jsx } from 'react/jsx-runtime';
import { c as cx } from './index-tZvMCc77.js';

import './SrOnly-BXm1DGl3.css';const styles = {
	"sr-only": "_sr-only_1d4d6_3"
};

const SrOnly = (props) => {
  const { className, ...rest } = props;
  const classNames = cx(styles["sr-only"], className);
  return /* @__PURE__ */ jsx("span", { "data-anv": "sr-only", className: classNames, ...rest });
};

export { SrOnly as S };
//# sourceMappingURL=SrOnly-BXm1DGl3-BJVodjQp.js.map
